import "./ReactionBar.css";
import useReactions from "./useReactions";

export default function ReactionBar({
  targetType,
  targetId,
  ownerId,
  currentUser,
  compact = false,
  onChange,
}) {
  const {
    counts,
    myReaction,
    react,
  } = useReactions(
    targetType,
    targetId,
    currentUser,
    ownerId,
    { onChange }
  );

  /**
   * Keep compact mode for any legacy callers.
   *
   * New HobbliHub public cards should use PublicItemSocialPreview
   * instead so the feed does not create one reaction query/hook
   * per card.
   */
  if (compact) {
    return (
      <div className="reaction-summary">
        {counts.love > 0 && (
          <span className="reaction-pill">
            ❤️ {counts.love}
          </span>
        )}

        {counts.jealous > 0 && (
          <span className="reaction-pill">
            🤤 {counts.jealous}
          </span>
        )}

        {counts.fire > 0 && (
          <span className="reaction-pill">
            🔥 {counts.fire}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="reaction-bar">
      <button
        className={`reaction-btn ${
          myReaction === "love" ? "active" : ""
        }`}
        onClick={() => react("love")}
      >
        ❤️ <span>Love</span>
        <span className="reaction-count">
          {counts.love}
        </span>
      </button>

      <button
        className={`reaction-btn ${
          myReaction === "jealous" ? "active" : ""
        }`}
        onClick={() => react("jealous")}
      >
        🤤 <span>Jealous</span>
        <span className="reaction-count">
          {counts.jealous}
        </span>
      </button>

      <button
        className={`reaction-btn ${
          myReaction === "fire" ? "active" : ""
        }`}
        onClick={() => react("fire")}
      >
        🔥 <span>Fire</span>
        <span className="reaction-count">
          {counts.fire}
        </span>
      </button>
    </div>
  );
}
